import Accordion, { AccordionPanel } from '@/components/Accordion';
import { numToOrdinalSuffix } from '@/utils/strings';
import SelectionsList from '../SelectionsList';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SelectionsModalCollectionsList = _ref => {
  let {
    collections,
    invalids,
    activeCollection,
    activeSelection,
    highlightColors,
    isAdding,
    textOverrides = {},
    sheetNames = [],
    onChangeAddMode = () => undefined,
    onActivateCollection = () => undefined,
    onActivateSelection = () => undefined,
    onRemoveSelection = () => undefined,
    onRemoveCollection = () => undefined
  } = _ref;
  return /*#__PURE__*/_jsx(Accordion, {
    children: collections.map((collection, collectionIndex) => {
      const selectionsCount = collection.length;
      const groupTitle = (textOverrides === null || textOverrides === void 0 ? void 0 : textOverrides.groupTitle) || 'Group';
      const panelTitle = `${numToOrdinalSuffix(collectionIndex + 1)} ${groupTitle}${selectionsCount > 0 ? ` (${selectionsCount})` : ''}`;
      return /*#__PURE__*/_jsx(AccordionPanel, {
        title: panelTitle,
        isFullHeight: true,
        isOpen: activeCollection === collectionIndex,
        onClick: () => {
          onActivateCollection(collectionIndex); // Deactivate active selections

          onActivateSelection(-1); // Auto activate/deactivate selections

          onChangeAddMode(selectionsCount ? false : true);
        },
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SelectionsList, {
            selections: collection,
            invalidSelections: invalids[collectionIndex],
            activeSelection: activeSelection,
            highlightColor: highlightColors[collectionIndex],
            collectionIndex: collectionIndex,
            isAdding: isAdding,
            sheetNames: sheetNames,
            onActivateSelection: onActivateSelection,
            onRemoveSelection: selectionIndex => {
              onRemoveSelection(collectionIndex, selectionIndex);
            },
            onChangeAddMode: onChangeAddMode
          }), collections.length > 1 && /*#__PURE__*/_jsx("button", {
            type: "button",
            className: styles.deleteTextButton,
            onClick: () => onRemoveCollection(collectionIndex),
            children: (textOverrides === null || textOverrides === void 0 ? void 0 : textOverrides.deleteCollectionButton) || 'Delete Group'
          })]
        })
      }, `collection-${collectionIndex}`);
    })
  });
};

export default SelectionsModalCollectionsList;